import nl from "./nl.lng.json";
import en from "./en.lng.json";
import da from "./da.lng.json";
import de from "./de.lng.json";
import fr from "./fr.lng.json";
import pt from "./pt.lng.json";
import es from "./es.lng.json";
import hu from "./hu.lng.json";
import sv from "./sv.lng.json";
import it from "./it.lng.json";
import pl from "./pl.lng.json";
import cs from "./cs.lng.json";
import uk from "./uk.lng.json";
import zh from "./zh.lng.json";
import sk from "./sk.lng.json";

export const defaultLocale = "nl";
export const fallbackLocale = "en";

export const languages = {
    nl: nl,
    en: en,
    da: da,
    de: de,
    fr: fr,
    pt: pt,
    es: es,
    hu: hu,
    sv: sv,
    it: it,
    pl: pl,
    cs: cs,
    uk: uk,
    zh: zh,
    sk: sk
};
